import {useTranslations} from 'next-intl';
import {PriceCurrencyRatio} from '@/libs/constants/common.constants';
import {spaceNumber} from '@/libs/number.util';
import PriceRangeInput from '@/components/shared/sidebars/widgets/PriceRangeInput';

export const pricesItems = (currency) => {
  const ratio = PriceCurrencyRatio[currency] ?? PriceCurrencyRatio.default;
  const values = [0, 500, 1000, 5000, 10000, 25000, 50000, 100000, 250000, 500000];
  return values.map(v => {
    const val = Math.round(v / ratio);
    return {
      value: val,
      title: spaceNumber(val)
    }
  });
};

export default function PriceRange({ currency, priceFromInput, priceToInput, priceRanges, onPriceRemove, onPriceChange }) {
  const t = useTranslations('catalog');
  return (
    <div className="widget ltn__price-filter-widget">
      <h4 className="ltn__widget-title ltn__widget-title-border">
        {t('filterByPrice')}
      </h4>
      <div className="price_filter">
        <div className="price_slider_amount">
          <PriceRangeInput
              currency={currency}
              priceFromInput={priceFromInput}
              priceToInput={priceToInput}
              priceRanges={priceRanges}
              onPriceRemove={onPriceRemove}
              onPriceChange={onPriceChange}
          />
        </div>
        {/*<div className="slider-range"></div>*/}
      </div>
    </div>
  );
};
